import React from 'react';
import { OptionLayoutSkeleton } from './OptionLayout.Skeleton';
export const OptionLayoutsSkeleton = ({ nbItems, showItemLabel, showLabel = true }) => {
    return (React.createElement("div", { className: `${showLabel ? 'mt:28' : 'mt:18'} d:flex fd:column` },
        showLabel &&
            React.createElement("div", { className: "d:flex mb:16" },
                React.createElement("div", { className: "skeleton fz:14 h:lh w:1/6" })),
        React.createElement("div", { className: "d:flex fxw:wrap m:-6" }, [...Array(nbItems)].map((l, i) => (React.createElement(OptionLayoutSkeleton, { key: i, showLabel: showItemLabel }))))));
};
